import { WsEventListener } from "@fidget/common/services/eventsListener";
import { logger } from "../../utils";
import { IProfanityStore } from "./ProfanityStore";

export class ProfanityEventHandler implements WsEventListener {
  constructor(private _storeFinder: () => IProfanityStore, public name: string) {}

  get profanityStore(): IProfanityStore {
    return this._storeFinder();
  }

  connected() {
    if (this.profanityStore.sharedOrgConfig?.profanitiesCheckingEnabled) {
      this.profanityStore.sharedSpinnerService
        .getProfanities()
        .then((profanities) => this.profanityStore.setProfanities(profanities.expressions))
        .catch((err) => logger.error({ message: "Couldn't load profanities", error: err }));
    }
  }
}
